
import { createApiClient } from 'Network/ApiClient';

export const ActivityNotCoveredAxiosInstance = createApiClient('ActivityNotCovered/');


